<template>
    <sa-page-layout ref="SaPostiLetto" :btnSaveVisible="true" :btnAnnullaVisible="true" :linkback="linkback" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource" class="sa-no-space">
        <template slot="table-body">
            <cot-tracciamento-chiamate-edit-component :showModalLoading="showModalLoading" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></cot-tracciamento-chiamate-edit-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import CotTracciamentoChiamateEditComponent from "../components/CotTracciamentoChiamateEditComponent.vue";
export default {
    components: { SaPageLayout, CotTracciamentoChiamateEditComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/cottracciamentochiamate",
            linkback: "/cot/tracciamentochiamate",
            jsonData: {},
        };
    },
    methods: {
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {},
        onAfterLoadData() {},
    },
};
</script>

<style></style>
